import React from 'react';
import {Route, Switch, Redirect} from 'react-router-dom';
import ManagersLogs from './components/Managers';
import ManagerChartsContainer from './components/ManagerCharts';
import ErrorBoundaryRoute from '../../../../containers/ErrorBoundaryRoute';
import DispatcherTimeTracking from "./components/DispatcherTimeTracking";
import HelpDeskTimeTracking from "./components/HelpDeskTimeTracking";
import HiringTimeTracking from "./components/HiringTimeTracking";
import DispatcherDailyActivities from "./components/DispatcherDailyActivities";
import DispatcherDailyGaps from "./components/DispatcherDailyGaps";
import Kpi_Scores from "./components/Kpi_Scores";
import Wos_Worked from "./components/Wos_Worked";
import Trip_Fees from "./components/Trip_Fees"
import ReadOnlyTORs from "./components/ReadOnlyTORs";
import FeEstimatesContainer from "./components/FeEstimates";
import ScheduleOptimizations from "./components/ScheduleOptimizations";
import AvCenter from "./components/AvCenter";
import AutomatedEmails from "./components/AutomatedEmails";
import IdleTasksAdmin from "./components/IdleTasksAdmin"

/*
	First is exact Route XYZ/
	Second is sub page(s) XYZ/ABC
	Third is sub page(s) with IDs XYZ/ABC/ID
	Last is non exact with ID. XYZ/ID
	Final is a redirect
 */
export default ({match, regions,roles, main_role}) => (
	<div>
		<Switch>
			<ErrorBoundaryRoute exact path={`${match.url}`}>
				<ManagerChartsContainer regions={regions} roles={roles}/>
			</ErrorBoundaryRoute>
			<ErrorBoundaryRoute exact path={`${match.url}/alerts`}>
				<ManagersLogs regions={regions} roles={roles}/>
			</ErrorBoundaryRoute>
			<ErrorBoundaryRoute exact path={`${match.url}/time_tracking`}>
				<DispatcherTimeTracking regions={regions} roles={roles}/>
			</ErrorBoundaryRoute>
			<ErrorBoundaryRoute exact path={`${match.url}/helpdesk_time_tracking`}>
				<HelpDeskTimeTracking regions={regions} roles={roles}/>
			</ErrorBoundaryRoute>
			<ErrorBoundaryRoute exact path={`${match.url}/hiring_time_tracking`}>
				<HiringTimeTracking regions={regions} roles={roles}/>
			</ErrorBoundaryRoute>
			<ErrorBoundaryRoute exact path={`${match.url}/schedule_optimizations`}>
				<ScheduleOptimizations regions={regions} roles={roles}/>
			</ErrorBoundaryRoute>
			<ErrorBoundaryRoute exact path={`${match.url}/time_tracking/daily_activities`}>
				<DispatcherDailyActivities regions={regions} roles={roles}/>
			</ErrorBoundaryRoute>
			<ErrorBoundaryRoute exact path={`${match.url}/time_tracking/daily_gaps`}>
				<DispatcherDailyGaps regions={regions} roles={roles}/>
			</ErrorBoundaryRoute>
			<ErrorBoundaryRoute exact path={`${match.url}/kpi_scores`}>
				<Kpi_Scores regions={regions} roles={roles}/>
			</ErrorBoundaryRoute>
			<ErrorBoundaryRoute exact path={`${match.url}/wos_worked`}>
				<Wos_Worked regions={regions} roles={roles}/>
			</ErrorBoundaryRoute>
			<ErrorBoundaryRoute exact path={`${match.url}/tripfees`}>
				<Trip_Fees regions={regions} roles={roles}/>
			</ErrorBoundaryRoute>
			<ErrorBoundaryRoute exact path={`${match.url}/rolling_tors`}>
				<ReadOnlyTORs regions={regions} roles={roles}/>
			</ErrorBoundaryRoute>
			<ErrorBoundaryRoute exact path={`${match.url}/fe_estimates`}>
				<FeEstimatesContainer regions={regions} roles={roles}/>
			</ErrorBoundaryRoute>
			<ErrorBoundaryRoute exact path={`${match.url}/av_center`}>
				<AvCenter regions={regions} roles={roles}/>
			</ErrorBoundaryRoute>
			<ErrorBoundaryRoute exact path={`${match.url}/inactive_avs`}>
				<Redirect to={`${match.url}/av_center`}/>
			</ErrorBoundaryRoute>
			<ErrorBoundaryRoute exact path={`${match.url}/automated_emails`}>
				<AutomatedEmails regions={regions} roles={roles}/>
			</ErrorBoundaryRoute>
			<ErrorBoundaryRoute exact path={`${match.url}/idle_tasks_admin`}>
				<IdleTasksAdmin regions={regions} roles={roles} main_role={main_role}/>
			</ErrorBoundaryRoute>


			<ErrorBoundaryRoute>
				<Redirect to={`${match.url}`} />
			</ErrorBoundaryRoute>
		</Switch>
	</div>
);
